import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-multi-lang'

import './TableActionBar.css'
import SettingContext from '../../services/context/setting-contentxt/setting-context';
import { InputField } from '../FormElements/FormElements';
import { ExpensesTypeMenu } from '../PredefinedMenus/PredefinedMenus';

interface ActionBarProps {
    title?: string;
    search?: Function;
    delete?: Function;
    add?: Function;
    addText?: string;
    showDelete?: boolean;
    showFilter?: boolean;
    second_button?: string;
    second_button_action?: Function;
    keyword?:string,
    edit?:Function,
    editText?:string,
    triggerFilter?:Function,
    date_from?:string,
    date_to?:string,
    setDateFrom?:Function,
    setDateTo?:Function
    dateFromError?:string|null,
    dateToError?:string|null,
    clearDate?:()=>void , 
    handleFilter?:Function ,
    filterValue?:any,

}

export default (props: ActionBarProps) => {

    const t = useTranslation()
  const { isMobile } = useContext(SettingContext);
    const [searchValue, setSearchValue] = useState<string>('')
    useEffect(()=>{
if (props.keyword) {
    setSearchValue(props.keyword)
}
    },[props.keyword])

    return(
        <div className="action-bar">
            { props.title ? <h2>{props.title}</h2> : "" }
            { props.search ?
           
            !isMobile?
             (<div className="search" >
                 <input type="text" value={ searchValue} placeholder={t('search')}
                 onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
                 onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
                     if(e.key === "Enter" && props.search)
                         props.search(e.currentTarget.value)
                 }} />
                 { searchValue === "" ?
                 <i className="icon-search" /> :
                 <i className="icon-close" onClick={() => {
                     setSearchValue("")
                     if(props.search)
                         props.search("")
                 }} /> }
             </div>) : 
             <div className='search'>
                  <input type="text" value={ searchValue} placeholder={t('search')}
                 onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
                 onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
                     if(e.key === "Enter" && props.search)
                         props.search(e.currentTarget.value)
                 }} />
                 { searchValue !== "" ?
                 //<i className="icon-search" /> :
                 <i className="icon-close" onClick={() => {
                     setSearchValue("")
                     if(props.search)
                         props.search("")}}/>:null}
            </div>
             : "" }

            <div className="actions" >
                

                { props.showDelete ?
                isMobile?
                  <i className="icon-delete" onClick={() => { if(props.delete) props.delete() }}></i>
                :
                 <button className="delete" onClick={() => { if(props.delete) props.delete() }}>
                    <i className="icon-delete"></i></button> : "" }

                { props.showFilter === false ?  "" : 
                
                
                  isMobile?
                  <i className="icon-filter-2" onClick={()=>props.triggerFilter?props.triggerFilter():null}></i>
                :
                <button className="filter" onClick={()=>props.triggerFilter?props.triggerFilter():null}>
                    <i className="icon-filter-2"></i> {t("filter")}</button> }

                { props.second_button ? 
                isMobile?
                <i className="icon-plus" onClick={() => { if(props.second_button_action) props.second_button_action()}}></i>
                :
                <button className="add secondary" onClick={() => { if(props.second_button_action) props.second_button_action() }}>
                    {props.second_button}</button> : "" }

                { props.add  && props.title !==t("bills")? 
                isMobile?
                    <i className="icon-plus" onClick={() => { if(props.add) props.add() }}></i>
                :
                <button className="add"  onClick={() => { if(props.add) props.add() }}>
              {  t("payment_vouchers") ? <i className='icon-reporting' style={{marginInline:'2px'}}></i>  :<i className="icon-plus"></i> }{props.addText}</button> : "" }
                    

                { props.edit  ?
                isMobile?
                 <i className="icon-edit" onClick={() => { if(props.edit) props.edit() }}></i>
                :
                <button className="add" style={{marginInline:'2px'}} onClick={() => { if(props.edit) props.edit() }}>
                    <i className="icon-edit"></i> {props.editText}</button> : ''}

              
            </div>
            <div className='action_options'>
              
               <div className="action_group">
                    
                        { props.setDateFrom  ?
                    
                        <InputField onChange={props.setDateFrom} value={props.date_from}
                        error={props.dateFromError} type='date'
                        label={t('from')} 
                        /> 
                        
                        : ''}
                    { props.setDateTo ?
                        
                        <InputField onChange={props.setDateTo} value={props.date_to}
                        error={props.dateFromError} type='date'
                        label={t('to')} min={props.date_from} disabled={!Boolean(props.date_from)}
                        
                      
                        /> : ''}


                    {
                        props.clearDate?
                        <button className="add animate_on_hover" style={{backgroundColor:'var(--gray-bg)',color:'black'}}
                         onClick={() => { if(props.clearDate) props.clearDate() }}>
                            <div className="animate_on_hover">
                                   <i className="icon-close icon" >

                                    </i> 
                                <span className="text">{t('clear')} </span>


                                
                                 
                            </div>
                            </button>: ''}
</div>
                      
                     {
                props.title === t('payment_vouchers')? 
                <ExpensesTypeMenu onChange={props.handleFilter} value={props.filterValue} />:''
               }
               

            
            </div>
        </div>
    )

}